import styled from '@emotion/styled'
import React from 'react'
import { createPropFilter } from '@news-mono/web-common'
import { calcRem, colors } from '../__styling'

export const StyledWrapper = styled('div')({
    position: 'relative',
    width: '100%',
})

export const StyledScroll = styled('div')({
    display: 'flex',
    gap: calcRem(12),
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    padding: `${calcRem(8)} 0`,
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
        display: 'none',
    },

    '&[data-disable-drag="true"]': {
        overflowX: 'hidden',
        scrollBehavior: 'auto',
    },
})

interface StyledButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
}

export const StyledButtonBase = styled('button', {
    shouldForwardProp: createPropFilter<StyledButtonProps>()(['className']),
})<StyledButtonProps>(() => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 5,
    width: calcRem(32),
    height: calcRem(32),
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    background: colors.white,
    color: colors.black,
    marginHorizontal: calcRem(8),
    textAlign: 'center',

    '&:disabled': {
        opacity: 0.3,
        cursor: 'default',
    },

    img: {
        marginTop: calcRem(3),
    },
}))

export const StyledButtonLeft = styled(StyledButtonBase)({
    left: calcRem(10),

    img: {
        marginLeft: calcRem(8),
        rotate: '180deg',
    },
})

export const StyledButtonRight = styled(StyledButtonBase)({
    right: calcRem(10),

    img: {
        marginRight: calcRem(8),
    },
})
